export default "__VITE_ASSET__C9pjc2Oi__"